import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7Segmented =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7Segmented, _React$Component);

  function F7Segmented(props, context) {
    _classCallCheck(this, F7Segmented);

    return _possibleConstructorReturn(this, _getPrototypeOf(F7Segmented).call(this, props, context));
  }

  _createClass(F7Segmented, [{
    key: "render",
    value: function render() {
      var self = this;
      var props = self.props;
      var className = props.className,
          raised = props.raised,
          raisedIos = props.raisedIos,
          raisedAurora = props.raisedAurora,
          raisedMd = props.raisedMd,
          round = props.round,
          roundIos = props.roundIos,
          roundAurora = props.roundAurora,
          roundMd = props.roundMd,
          strong = props.strong,
          strongIos = props.strongIos,
          strongMd = props.strongMd,
          strongAurora = props.strongAurora,
          id = props.id,
          style = props.style,
          tag = props.tag;
      var classNames = Utils.classNames(className, {
        segmented: true,
        'segmented-raised': raised,
        'segmented-raised-ios': raisedIos,
        'segmented-raised-aurora': raisedAurora,
        'segmented-raised-md': raisedMd,
        'segmented-round': round,
        'segmented-round-ios': roundIos,
        'segmented-round-aurora': roundAurora,
        'segmented-round-md': roundMd,
        'segmented-strong': strong,
        'segmented-strong-ios': strongIos,
        'segmented-strong-md': strongMd,
        'segmented-strong-aurora': strongAurora
      }, Mixins.colorClasses(props));
      var SegmentedTag = tag;
      return React.createElement(SegmentedTag, {
        id: id,
        style: style,
        className: classNames
      }, this.slots['default']);
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }]);

  return F7Segmented;
}(React.Component);

__reactComponentSetProps(F7Segmented, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  raised: Boolean,
  raisedIos: Boolean,
  raisedMd: Boolean,
  raisedAurora: Boolean,
  round: Boolean,
  roundIos: Boolean,
  roundMd: Boolean,
  roundAurora: Boolean,
  strong: Boolean,
  strongIos: Boolean,
  strongMd: Boolean,
  strongAurora: Boolean,
  tag: {
    type: String,
    default: 'div'
  }
}, Mixins.colorProps));

F7Segmented.displayName = 'f7-segmented';
export default F7Segmented;